import { render, staticRenderFns } from "./confirmacao.vue?vue&type=template&id=97545b12&"
import script from "./confirmacao.vue?vue&type=script&lang=js&"
export * from "./confirmacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports